import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ContentService} from "../../../_services/content.service";
import {SnackbarService} from "../../../_services/snackbar.service";
import {MediaItem, MinimalMemory, TimelineListItem} from "../../../_types/memorybox";


interface mediaData {
    media: MediaItem,
    timelineId: number,
    album: number,
    unhide: boolean,
    copyMedia: boolean,
}

@Component({
    selector: 'app-move-media',
    templateUrl: './move-media.component.html',
    styleUrl: './move-media.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoveMediaComponent {
    currentMedia: MediaItem | undefined;
    timeline: number | undefined;
    album: number | undefined;
    unhide: boolean = false;
    copyMedia: boolean = false;

    constructor(@Inject(MAT_DIALOG_DATA) protected data: mediaData,
                private dialogRef: MatDialogRef<MoveMediaComponent>,
                public contentService: ContentService,
                private snackbarService: SnackbarService) {
        if (data.media) {
            this.currentMedia = data.media;
            this.album = data.album
            this.unhide = data.unhide
            this.timeline = data.timelineId
            this.copyMedia = data.copyMedia;
        }
    }

    selectMemory(memory?: MinimalMemory | undefined): void {
        if (memory && 'id' in memory) {
            this.album = memory.id;
        } else {
            this.album = undefined
        }
    }

    moveMedia(): void {
        if (!this.currentMedia?.id || !this.album) return;
        this.contentService.moveMedia(this.currentMedia.id, this.album, this.unhide).subscribe({
            next: r => {
                this.snackbarService.openSnackBar('Media Successfully moved to album', 'success')
                this.dialogRef.close()
            }, error: error => {
                this.snackbarService.openSnackBar(error, 'error')
            }
        });

    }

    copyMediaOver(): void {
        if (!this.currentMedia?.id || !this.album) return;
        this.contentService.copyMedia(this.currentMedia.id, this.album).subscribe({
            next: r => {
                this.snackbarService.openSnackBar('Media Successfully duplicated to album', 'success')
                this.dialogRef.close()
            }, error: error => {
                this.snackbarService.openSnackBar(error, 'error')
            }
        })
    }

    selectedTimeline(timeline?: TimelineListItem | undefined): void {
        if (timeline) {
            this.timeline = timeline.id;
        } else {
            this.timeline = undefined
        }
    }
}

